import { View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { TdDecoratorViewModel } from "./tdDecorator-viewModel"

export class TdDecoratorView extends View<TdDecoratorViewModel>{
    GetViewUniqueId(): string {
        return "V-111A6B5E-7904-4C93-AD87-8356DE89910B"
    }
    loadHtml(): string {
        let element = require('./tdDecorator.html').default;
        let style = require('./tdDecorator.less');
        return element;
    }
    constructor() {
        super();
        try{
            this['_Class']=null;
            Object.defineProperty(this,'Class',{
                set : function(v){this['_Class']=v;}.bind(this),
                get : function(){return this['_Class']}.bind(this),
                configurable:true
            })

            this['_Style']=null;
            Object.defineProperty(this,'Style',{
                set : function(v){this['_Style']=v;}.bind(this),
                get : function(){return this['_Style']}.bind(this),
                configurable:true
            })
            }catch{}
    }

    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;

    addNewBefore(){
        this.dataContext.addNewBefore();
    }
    addNewAfter(){
        this.dataContext.addNewAfter();
    }
    delete(){
        this.dataContext.delete();
    }
}
